<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>SMS Count Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Month</u></label>
        <input type="month" [(ngModel)]="filterable.month" class="form-control" placeholder="Month">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select #selectedCountry class="form-control" placeholder="Country" (change)="changeCountry(selectedCountry.value)">
          <option *ngFor="let country of countryList | keyvalue" [value]="country.value" [selected]="country.value == selectedCountry">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
          <label for=""><span class="text-danger">* </span><u>Filter by Operator</u></label>
          <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator">
            <option *ngFor="let op of operatorList" [ngValue]="op">{{op}}</option>
          </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>OTP SMS Price</u></label>
        <input type="number" min="0" [(ngModel)]="filterable.otpPrice" class="form-control" placeholder="OTP SMS Price">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Sub SMS Price</u></label>
        <input type="number" min="0" [(ngModel)]="filterable.subscribePrice" class="form-control" placeholder="Sub SMS Price">
      </div>
    </div>
    <div class="row">

      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Unsub SMS Price</u></label>
        <input type="number" min="0" [(ngModel)]="filterable.unsubscribePrice" class="form-control" placeholder="Unsub SMS Price<">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Reminder SMS Price</u></label>
        <input type="number" min="0" [(ngModel)]="filterable.reminderPrice" class="form-control" placeholder="Reminder SMS Price">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Charge MT Price</u></label>
        <input type="number" min="0" [(ngModel)]="filterable.mtChargePrice" class="form-control" placeholder="Charge MT SMS Price">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Free MT Price</u></label>
        <input type="number" min="0" [(ngModel)]="filterable.mtFreePrice" class="form-control" placeholder="Free MT SMS Price">
      </div>
      <div class="col">
        <label for=""><u>Data Flag</u></label>
        <select [(ngModel)]="filterable.realtime" class="form-control" placeholder="realtime">
          <option *ngFor="let rtf of realtimeFlags | keyvalue" [ngValue]="rtf.value">{{rtf.key}}</option>
        </select>
      </div>
      <div class="col text-right align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
        <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
        <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}<span  *ngIf="resultName != ''"  > - <span class="font-weight-bold font-italic text-danger">{{resultName}}</span> </span>
  </div>

</div>
<!-- <div class="table-responsive"> -->
<table id="smsCountList" class="table table-striped table-bordered mt-3" style="width:100%">
  <thead class="text-center">
    <tr>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Affiliate</th>
      <th>Total Amount</th>
      <th>OTP Count</th>
      <th>OTP Amount</th>
      <th>Sub Count</th>
      <th>Sub Amount</th>
      <th>Unsub Count</th>
      <th>Unsub Amount</th>
      <th>Reminder Count</th>
      <th>Reminder Amount</th>
      <th>Charge MT Count</th>
      <th>Charge MT Amount</th>
      <th>Free MT Count</th>
      <th>Free MT Amount</th>
      <th>Retention Weekly</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="17">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="17">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let smsCount of smsCountList">
      <td class="text-center">{{smsCount.shortCode}}</td>
      <td class="text-center">{{smsCount.keyword}}</td>
      <td class="text-center">{{smsCount.affiliate}}</td>
      <td class="text-right">{{smsCount.totalAmount}}</td>
      <td class="text-center">{{smsCount.otpCount}}</td>
      <td class="text-right">{{smsCount.otpAmount}}</td>
      <td class="text-center">{{smsCount.subscribeCount}}</td>
      <td class="text-right">{{smsCount.subscribeAmount}}</td>
      <td class="text-center">{{smsCount.unsubscribeCount}}</td>
      <td class="text-right">{{smsCount.unsubscribeAmount}}</td>
      <td class="text-center">{{smsCount.reminderCount}}</td>
      <td class="text-right">{{smsCount.reminderAmount}}</td>
      <td class="text-center">{{smsCount.mtChargeCount}}</td>
      <td class="text-right">{{smsCount.mtChargeAmount}}</td>
      <td class="text-center">{{smsCount.mtFreeCount}}</td>
      <td class="text-right">{{smsCount.mtFreeAmount}}</td>
      <td class="text-center">{{smsCount.retentionArr}}</td>
    </tr>
  </tbody>
</table>
<!-- </div> -->

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
